/**
 *  Ajax Autocomplete for jQuery, version 1.1.3
 *  (c) 2010 Tomas Kirda
 *
 *  Ajax Autocomplete for jQuery is freely distributable under the terms of an MIT-style license.
 *  For details, see the web site: http://www.devbridge.com/projects/autocomplete/jquery/
 *
 *  Last Review: 04/19/2010
 */

(function ($) {
    var reEscape = new RegExp('(\\' + ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'].join('|\\') + ')', 'g');

    function fnFormatResult(value, data, currentValue) {
        var pattern = '(' + currentValue.replace(reEscape, '\\$1') + ')';
        return value.replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>');
    }

    function getURLParameter(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null
    }

    function AutocompletePredictive(el, options) {
        this.el = $(el);
        this.el.attr('autocomplete', 'off');

        this.stopPredict = false;
        this.predictive = [];
        this.badQueries = [];
        this.selectedIndex = -1;
        this.currentValue = this.el.val();
        this.intervalId = 0;
        this.cachedResponse = [];
        this.onChangeInterval = null;
        this.ignoreValueChange = false;
        this.serviceUrl = options.serviceUrl;
        this.isLocal = false;
        this.item = 'div.item.selecteable';
        this.itemBts = 'a.selecteable';
        this.options = {
            autoSubmit: false,
            minChars: 1,
            maxHeight: 300,
            deferRequestBy: 200,
            width: 0,
            highlight: true,
            params: {},
            fnFormatResult: fnFormatResult,
            delimiter: null,
            zIndex: 9999,
            onSelect: function () {
            },
            modifyUrl: function () {
            },
            getBuscardor: function () {
            },
            isBootStrap: true
        };

        this.initialize(options);
        this.setOptions(options);
    }

    $.fn.autocompletepredictive = function (options) {
        return new AutocompletePredictive(this.get(0) || $('<input>'), options);
    };

    AutocompletePredictive.prototype = {
        killerFn: null,
        initialize: function (options) {
            var me, uid, autocompleteElId, isBootStrap;
            me = this;

            $(me.el).attr('firstTime', 'false');
            uid = Math.floor(Math.random() * 0x100000).toString(16);
            autocompleteElId = 'Autocomplete_' + uid;

            this.killerFn = function (e) {
                if ($(e.target).parents('.autocomplete').length === 0) {
                    me.killSuggestions();
                    me.disableKillerFn();
                }
            };

            if (!this.options.width) {
                this.options.width = this.el.width();
            }

            isBootStrap = typeof options.isBootStrap === 'undefined' ? this.options.isBootStrap : options.isBootStrap;
            if (isBootStrap) {
                this.mainContainerId = 'AutocompleteContainter_' + uid;
                $('<div id="' + this.mainContainerId + '" class="autocompleteContainter autocomplete-containter-ext container col-xs-12 col-sm-12" style="position:absolute;z-index:9999;"><div class="autocompleteContainter autocomplete" id="' + autocompleteElId + '" style="display:none;"></div></div>').appendTo('body');
            } else {
                this.mainContainerId = 'AutocompleteContainter_' + uid;
                $('<div id="' + this.mainContainerId + '" style="position:absolute;z-index:9999;"><div class="autocomplete-w1"><div class="autocomplete" id="' + autocompleteElId + '" style="display:none;"></div></div></div>').appendTo('body');
            }

            this.container = $('#' + autocompleteElId);
            this.fixPosition();

            $(window).resize(function () {
                if ($(me.el).is(':visible')) {
                    me.fixPosition();
                } else {
                    me.hide();
                    // Si estoy en version mobile, y quiero pasar a Web, intancio el otro input del predictivo
                    if ($('input#buscadorWords-full').is(':visible') && $('input#buscadorWords-full').attr('firstTime') === 'true') {
                        var searchPredictAndSuggest = new window.fwk.controllers.searchPredictAndSuggest();
                        searchPredictAndSuggest.initialize();
                    }
                }

            });

            this.el.keyup(function (e) {
                me.onKeyUp(e);
                switch ($(me.el).attr('id')) {
                    case 'buscadorWords-full':
                        $('#buscadorWords-mobile').val($(me.el).val());
                        break;
                    case 'buscadorWords-mobile':
                        $('#buscadorWords-full').val($(me.el).val());
                        break;
                }
            });

            this.el.blur(function () {
                me.enableKillerFn();
            });

            this.el.focus(function () {
                me.fixPosition();
            });

            if (window.opera) {
                this.el.keypress(function (e) {
                    me.onKeyPress(e);
                });
            } else {
                this.el.keydown(function (e) {
                    me.onKeyPress(e);
                });
            }
        },
        clearSelected: function () {
            var item = this.options.isBootStrap ? this.itemBts : this.item;
            $(item).removeClass('selected');
        },
        mouseBind: function () {
        },
        setOptions: function (options) {
            var o = this.options;
            $.extend(o, options);
            if (o.lookup) {
                this.isLocal = true;
                if ($.isArray(o.lookup)) {
                    o.lookup = {suggestions: o.lookup, data: []};
                }
            }
            $('#' + this.mainContainerId).css({zIndex: o.zIndex});
        },
        clearCache: function () {
            this.cachedResponse = [];
            this.badQueries = [];
        },
        disable: function () {
            this.disabled = true;
        },
        enable: function () {
            this.disabled = false;
        },
        fixPosition: function () {
            var offset = this.el.offset();
            if (this.el.attr('id') === 'buscadorWords-mobile') {
                $('#' + this.mainContainerId).css({top: (offset.top + this.el.innerHeight()) + 'px'});
            } else {
                $('#' + this.mainContainerId).css({
                    top: (offset.top + this.el.innerHeight()) + 'px',
                    left: offset.left + 'px'
                });
            }
        },
        enableKillerFn: function () {
            var me = this;
            $(document).bind('click', me.killerFn);
        },
        disableKillerFn: function () {
            var me = this;
            $(document).unbind('click', me.killerFn);
        },
        killSuggestions: function () {
            var me = this;
            this.stopKillSuggestions();
            this.intervalId = window.setInterval(function () {
                me.hide();
                me.stopKillSuggestions();
            }, 300);
        },
        stopKillSuggestions: function () {
            window.clearInterval(this.intervalId);
        },
        stopAndClose: function () {
            this.stopPredict = true;
            this.hide();
        },
        goTo: function (ev) {
            if (typeof ev !== 'undefined') {
                ev.stopImmediatePropagation();
                ev.preventDefault();
            }

            if (typeof window.autocomplete !== 'undefined') {
                window.autocomplete.abort();
            } else {
                this.hide();
            }

            if (typeof search === 'undefined') {
                this.stopAndClose();
            } else {
                if (typeof $(this.el).attr('fakeSearch') === 'undefined' || parseInt($(this.el).attr('fakeSearch')) === 0) {
                    this.options.parent.modifyUrl(this.getSelected());
                }
            }

            this.options.onSelect(this.getSelected());
        },
        onKeyPress: function (e) {
            var empty = false;

            switch (e.keyCode) {
                case 27: //KEY_ESC:
                    this.clearSelected();
                    this.el.val(this.currentValue);
                    this.hide();
                    break;
                case 9: //KEY_TAB:
                case 13: //KEY_RETURN:
                    if ($.trim(this.el.val()) === '') {
                        this.currentValue = '';
                    }
                    else
                    {this.goTo(e)}
                    return true;
                    break;
                case 38: //KEY_UP:
                    this.moveUp();
                    break;
                case 40: //KEY_DOWN:
                    this.moveDown();
                    break;
                case 37: // KEY_LEFT
                case 39: // KEY_RIGHT
                    return true;
                    break;
                default:
                    this.clearSelected();
                    return;
            }

            e.stopImmediatePropagation();
            e.preventDefault();
        },
        onKeyUp: function (e) {
            if (this.disabled) {
                return;
            }

            var empty = false;

            switch (e.keyCode) {
                case 38: // KEY_UP:
                case 40: // KEY_DOWN:
                    return;
                    break;
                case 13: // KEY_ENTER
                    if (typeof window.autocomplete !== 'undefined') {
                        window.autocomplete.abort();
                    } else {
                        this.hide();
                    }
                    break;
                case 8:  // KEY_BACKSPACE
                case 46: // KEY_SUPR
                    if ($.trim(this.el.val()) === '') {
                        empty = true;
                    }
                    break;
            }

            clearInterval(this.onChangeInterval);

            if (this.currentValue !== this.el.val()) {
                if (this.options.deferRequestBy > 0) {
                    // Defer lookup in case when value changes very quickly:
                    var me = this;
                    this.onChangeInterval = setInterval(function () {
                        me.onValueChange();
                    }, this.options.deferRequestBy);
                } else {

                    if (empty) {
                        this.el.val();
                        this.currentValue = '';
                        if (typeof window.autocomplete !== 'undefined') {
                            window.autocomplete.abort();
                        }
                        this.hide();
                    } else {
                        this.onValueChange();
                    }

                }
            }
        },
        onValueChange: function () {
            clearInterval(this.onChangeInterval);
            this.currentValue = this.el.val();
            var q = this.getQuery(this.currentValue);
            this.selectedIndex = -1;

            if (this.ignoreValueChange) {
                this.ignoreValueChange = false;
                return;
            }

            if (q === '' || q.length < this.options.minChars) {
                this.hide();
            } else {
                this.getSuggestions(q);
            }

            this.el.trigger('onValueChange', this.el.val());
        },
        getQuery: function (val) {
            var d, arr;
            d = this.options.delimiter;
            if (!d) {
                return $.trim(val);
            }
            arr = val.split(d);
            return $.trim(arr[arr.length - 1]);
        },
        getSuggestionsLocal: function (q) {
            var ret, arr, len, val, i;
            arr = this.options.lookup;
            len = arr.suggestions.length;
            ret = {suggestions: [], data: []};
            q = q.toLowerCase();

            for (i = 0; i < len; i++) {
                val = arr.suggestions[i];

                if (val.toLowerCase().indexOf(q) === 0) {
                    ret.suggestions.push(val);
                    ret.data.push(arr.data[i]);
                }
            }
            return ret;
        },
        getSuggestions: function (q) {
            //remporal solution for filters

            var filterPS=null;
            if(window.metadata&&window.metadata.byr_filterlist_configuration) {
                filterPS=JSON.parse(window.metadata.byr_filterlist_configuration);
                filterPS = filterPS[window.utils.userType.checkRegion()] || filterPS.default;
                if (filterPS && filterPS.filterlist)
                {
                    filterPS = filterPS.filterlist;
                    //mthis.urlPredict=mthis.urlPredict+'&filter='+filterPS;
                }

            }
            //ENDS tempora solution

            var cr, me;
            cr = this.isLocal ? this.getSuggestionsLocal(q) : this.cachedResponse[q];
            if (cr && $.isArray(cr.suggestions)) {
                this.suggest();
            } else if (!this.isBadQuery(q)) {
                me = this;
                me.options.params.query = q;

                if (typeof window.autocomplete != 'undefined') {
                    window.autocomplete.abort();
                }
                if (this.stopPredict === false) {
                    window.autocomplete = $.get(
                        this.serviceUrl,
                        {
                            value: me.options.params.query,
                            api_version: window.getConfig.api_version,
                            authpn: window.getConfig.authpn,
                            authpt: window.getConfig.authpt,
                            format: 'json',
                            device_id: 'web',
                            device_category: 'web',
                            device_model: 'web',
                            device_type: 'web',
                            device_manufacturer: 'generic',
                            commontype: 'full',
                            HKS: window.utils.userType.checkHks(),
                            filterlist:filterPS
                        },
                        function (data) {
                            data.response.query = data.entry.value;
                            me.processResponse(data.response);
                            if (navigator.userAgent.match(/msie\ ?(7|8)/i)) {
                                window.autocomplete = undefined;
                            } else {
                                delete(window.autocomplete);
                            }
                        },
                        'json'
                    );
                    this.el.trigger('onGetSuggestions', [q]);
                }
            }
        },
        isBadQuery: function (q) {
            var i = this.badQueries.length;
            while (i--) {
                if (q.indexOf(this.badQueries[i]) === 0) {
                    return true;
                }
            }
            return false;
        },
        hide: function () {
            this.enabled = false;
            this.selectedIndex = -1;
            this.container.hide();
        },
        suggest: function () {
            var mthis = this,
                predictive = typeof mthis.predictive.prediction === 'undefined' ? false : mthis.predictive.prediction,
                html = '';

            mthis.container.html('');

            var movies =  {
                data: predictive.movies ? predictive.movies.movie : [],
                label: window.utils.getMeta.translations('predict_search_content_label'),
                type: 'movie'
            };

            var moviesFox =  {
                data: (predictive.fox&&predictive.fox.movies&&predictive.fox.movies.movie)? predictive.fox.movies.movie : [],
                label:window.utils.getMeta.translations('predictSearch_fox_movie_label')||window.utils.getMeta.translations('predict_search_content_label')+" Fox",
                type: 'movie'
            };

          var moviesFoxv3 =  {
            data: (predictive.foxv3&&predictive.foxv3.movies&&predictive.foxv3.movies.movie)? predictive.foxv3.movies.movie : [],
            label:window.utils.getMeta.translations('predictSearch_fox_movie_label')||window.utils.getMeta.translations('predict_search_content_label')+" Fox",
            type: 'movie'
          };

            var moviesHBO =  {
                data: (predictive.hbo&&predictive.hbo.movies&&predictive.hbo.movies.movie)? predictive.hbo.movies.movie : [],
                label:window.utils.getMeta.translations('predictSearch_hbo_movie_label')||window.utils.getMeta.translations('predict_search_content_label')+" HBO",
                type: 'movie'
            };

            var moviesNOGGIN = {
                data: (predictive.noggin &&predictive.noggin.movies && predictive.noggin.movies.movie) ? predictive.noggin.movies.movie : [],
                label: window.utils.getMeta.translations('predictSearch_noggin_label')||window.utils.getMeta.translations('predict_search_content_label')+"   NOGGIN",
                type: 'movie'
            };

            var series = {
                data: predictive.series ? predictive.series.serie : [],
                label: window.utils.getMeta.translations('predict_search_series_label'),
                type: 'serie'
            };
            var seriesFox = {
                data: (predictive.fox&&predictive.fox.series&&predictive.fox.series.serie) ? predictive.fox.series.serie : [],
                label: window.utils.getMeta.translations('predictSearch_fox_serie_label')||window.utils.getMeta.translations('predict_search_series_label')+"   FOX",
                type: 'serie'
            };

          var seriesFoxv3 = {
            data: (predictive.foxv3&&predictive.foxv3.series&&predictive.foxv3.series.serie) ? predictive.foxv3.series.serie : [],
            label: window.utils.getMeta.translations('predictSearch_fox_serie_label')||window.utils.getMeta.translations('predict_search_series_label')+"   FOX",
            type: 'serie'
          };

            var seriesHBO = {
                data: (predictive.hbo&&predictive.hbo.series&&predictive.hbo.series.serie) ? predictive.hbo.series.serie : [],
                label: window.utils.getMeta.translations('predictSearch_hbo_serie_label')||window.utils.getMeta.translations('predict_search_series_label')+"   HBO",
                type: 'serie'
            };

            var seriesNOGGIN = {
                data: (predictive.noggin &&predictive.noggin.series && predictive.noggin.series.serie) ? predictive.noggin.series.serie : [],
                label: window.utils.getMeta.translations('predictSearch_noggin_serie_label')||window.utils.getMeta.translations('predict_search_series_label')+"   NOGGIN",
                type: 'serie'
            };

            /* CRACKLE */
            var moviesCrackle =  {
                data: (predictive.crackle&&predictive.crackle.movies&&predictive.crackle.movies.movie)? predictive.crackle.movies.movie : [],
                label:window.utils.getMeta.translations('predictSearch_crackle_movie_label')||window.utils.getMeta.translations('predict_search_content_label')+"   CRACKLE",
                type: 'movie'
            };
            var seriesCrackle = {
                data: (predictive.crackle &&predictive.crackle.series && predictive.crackle.series.serie) ? predictive.crackle.series.serie : [],
                label: window.utils.getMeta.translations('predictSearch_crackle_serie_label')||window.utils.getMeta.translations('predict_search_series_label')+"   CRACKLE",
                type: 'serie'
            };
            /* END CRACKLE */

            var talents = {
                data: predictive.talents ? predictive.talents.talent : [],
                label: window.utils.getMeta.translations('predict_search_talent_label'),
                type: 'talent'
            };
            var genres = {
                data: predictive.genres ? predictive.genres.genre : [],
                label: window.utils.getMeta.translations('predict_search_related_title_label'),
                type: 'genre'
            };

            if (mthis.predictive.suggest && mthis.predictive.suggest[0] && mthis.predictive.suggest[0].common) {
                var suggests = {
                    data: mthis.predictive.suggest[0].common,
                    label: window.utils.getMeta.translations('home_user_recome2one_second_title')
                };

                html += mthis.htmlFactorySuggest(suggests);
            }

            $.each([movies,moviesFox, moviesFoxv3, moviesHBO, series,seriesFox, seriesFoxv3, seriesHBO, moviesNOGGIN, seriesNOGGIN, moviesCrackle, seriesCrackle, talents, genres], function (key, value) {

                html += mthis.htmlFactory(value);
            });

            $(html).appendTo(mthis.container);
            mthis.container.show();
            mthis.mouseBind();
        },
      /** Secondary suggestions **/
        htmlFactory: function (data) {
            var html = '',
              lengthData = data.data.length,
              mthis = this;

            if (lengthData <= 0) {
                return '';
            }

            if (mthis.options.isBootStrap) {
                var type = data.type;
                var link_url, seo_name;
                var name = null;
                html += '<div class="autocomplete-category autocomplete-category-' + type + ' ">';
                html += '<h5>' + data['label'] + '</h5>';
                html += '<ul class="nav nav-pills nav-stacked">';
                for (var i = 0; i < lengthData; i++) {
                    if (typeof data.data[i].id === 'undefined') {
                        data.data[i].id = data.data[i].group_id;
                    }

                    if (data.data[i].title) {
                        name = data.data[i].title;
                    } else {
                        name = data.data[i].name;
                    }

                    seo_name = String(name).replace(/\s+/g, '-');
                    seo_name = seo_name.replace(/\//g, '');

                    switch (type) {
                        case 'suggest':
                        case 'movie':
                        case 'serie':
                            link_url = '/' + window.utils.userType.checkRegion() + '/vcard/home/' + encodeURIComponent(seo_name) + '/' + data.data[i].id;
                            break;
                        case 'talent':
                            link_url = '/' + window.utils.userType.checkRegion() + '/search?type=talent&id=' + data.data[i].id + '&q=' + encodeURIComponent(name);
                            break;
                        case 'genre':
                            link_url = '/' + window.utils.userType.checkRegion() + '/search?type=genre&q=' + encodeURIComponent(name);
                            break;
                        case 'unaviable':
                            link_url = '/' + window.utils.userType.checkRegion() + '/search?q=' + encodeURIComponent(name);
                            break;
                    }

                    html += '<li>';
                    html += '<a href="' + link_url + '" class="selecteable" idContent="';
                    html += data.data[i].id + '" title="' + name + '" data-type="' + type + '">';

                    if (typeof data.data[i].image_small !== 'undefined' && type == 'suggest') {
                        html += '<img src="' + data.data[i].image_small + '" class="col-xs-12 padding-bottom-1">';
                    }

                    html += mthis.highlightHtml(name, mthis.predictive.query);
                    html += '</a>';
                    html += '</li>';
                }
                html += '</ul>';
                html += '</div>';

            } else {
                html += mthis.constructNObootstrap(data);
            }
            return html;
        },
        /** Main Suggest **/
        htmlFactorySuggest: function(suggest) {
            var html = '';
            var extraClass = 'hidden-xs hidden-sm';

            html += '<div class="autocomplete-category autocomplete-category-suggest">';
            html += '<h5>' + suggest['label'] + '</h5>';
            html += '<ul class="nav nav-pills nav-stacked">';

            if (typeof suggest.data.id === 'undefined') {
                suggest.data.id = suggest.data.group_id;
            }

            var seo_name = String(suggest.data.title).replace(/\s+/g, '-');
            seo_name = seo_name.replace(/\//g, '');

            var link_url = '/' + window.utils.userType.checkRegion() + '/vcard/home/' + encodeURIComponent(seo_name) + '/' + suggest.data.id;
            html += '<li>';
            html += '<a href="' + link_url + '" class="selecteable" idContent="';
            html += suggest.data.id + '" title="' + suggest.data.title + '" data-type="suggest">';
            html += '<img src="' + suggest.data.image_small + '" class="col-xs-12 padding-bottom-1 ' + extraClass + '">';
            html += this.highlightHtml(suggest.data.title, this.predictive.query);
            html += '</a>';
            html += '</li>';
            html += '</ul>';
            html += '</div>';

            return html;
        },
        highlightHtml: function (value, string) {
           if(value) {
                var reEscape = new RegExp('(\\' + ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'].join('|\\') + ')', 'g');
                var pattern = '(' + string.replace(reEscape, '\\$1') + ')';
                return value.replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>');
            }
        },
        processResponse: function (response) {
            if (typeof response.prediction === 'undefined') {
                response.prediction = [];
            }
            if (typeof response.suggest === 'undefined') {
                response.suggestions = [];
            }
            if (!this.options.noCache) {
                this.cachedResponse[response.query] = response;
                if (response.predictive.length === 0) {
                    this.badQueries.push(response.query);
                }
            }

            if (response.query === this.getQuery(this.currentValue)) {
                this.predictive = response;
                this.suggest();
            }
        },
        getFirstItem: function () {
            if (this.options.isBootStrap) {
                return $(this.itemBts).first();
            } else {
                return $(this.item)[0];
            }
        },
        getLastItem: function () {
            if (this.options.isBootStrap) {
                return $(this.itemBts).last();
            } else {
                return $(this.item)[$(this.item).length - 1];
            }
        },
        moveUp: function () {
            var item = this.options.isBootStrap ? this.itemBts : this.item;

            if ($(item + '.selected').length === 0) {
                $(this.getLastItem()).addClass('selected');
            } else {
                if ($(this.getFirstItem()).hasClass('selected')) {
                    this.clearSelected();
                    $(this.getLastItem()).addClass('selected');
                    return;
                }
                var selecteable = $(item);

                $(item).each(function (index) {
                    if ($(this).hasClass('selected')) {
                        $(this).removeClass('selected');
                        $(selecteable[parseInt(index) - 1]).addClass('selected');
                        return false;
                    }
                });
            }
        },
        moveDown: function () {
            var item = this.options.isBootStrap ? this.itemBts : this.item;

            if ($(item + '.selected').length === 0) {
                $(this.getFirstItem()).addClass('selected');
            } else {
                if ($(this.getLastItem()).hasClass('selected')) {
                    this.clearSelected();
                    $(this.getFirstItem()).addClass('selected');
                    return;
                }
                var selecteable = $(item);

                selecteable.each(function (index) {
                    if ($(this).hasClass('selected')) {
                        $(this).removeClass('selected');
                        $(selecteable[parseInt(index) + 1]).addClass('selected');
                        return false;
                    }
                });
            }
        },
        getSelected: function () {
            var params = {},
                item = this.options.isBootStrap ? this.itemBts : this.item;

            if ($(item + '.selected').length === 1) {
                params.id = $(item + '.selected').attr('idContent');
                params.text = $(item + '.selected').attr('title');
                params.url = $(item + '.selected').attr('href');
            } else {
                params.text = this.options.params.query;
            }

            return params;
        }
    };
}(jQuery));
